import { z } from "zod";

import { constantsData } from "@/data";

export const dataSourceCategoryFormSchema = z.object({
    category: z.string().optional(),
    description: z.string().optional(),
    id: z.string().optional(),
    name: z.string().min(
        1,
        { message: constantsData.msgs.requiredField },
    ),
});
